module.exports = __webpack_public_path__ + "assets/images/project/icon/gender_icon.svg?v=b2420eea";